import { brighten, getValue } from "../utils.js";

export const CHART_COLOR = {
  "Color.Chart.1": {
    defaultValue: "#6979dc",
    referredIn: ["Color.Chart.Brighten.1"]
  },
  "Color.Chart.2": {
    defaultValue: "#f28e2b",
    referredIn: ["Color.Chart.Brighten.2"]
  },
  "Color.Chart.3": {
    defaultValue: "#e15759",
    referredIn: ["Color.Chart.Brighten.3"]
  },
  "Color.Chart.4": {
    defaultValue: "#76b7b2",
    referredIn: ["Color.Chart.Brighten.4"]
  },
  "Color.Chart.5": {
    defaultValue: "#9f6490",
    referredIn: ["Color.Chart.Brighten.5"]
  },
  "Color.Chart.6": {
    defaultValue: "#65a35b",
    referredIn: ["Color.Chart.Brighten.6"]
  },
  "Color.Chart.7": {
    defaultValue: "#e8bf39",
    referredIn: ["Color.Chart.Brighten.7"]
  },
  "Color.Chart.8": {
    defaultValue: "#5783b1",
    referredIn: ["Color.Chart.Brighten.8"]
  },
  "Color.Chart.9": {
    defaultValue: "#fd8897",
    referredIn: ["Color.Chart.Brighten.9"]
  },
  "Color.Chart.10": {
    defaultValue: "#c4cc65",
    referredIn: ["Color.Chart.Brighten.10"]
  },
  "Color.Chart.Brighten.1": {
    valueFunc: (meta) => {
      return brighten(getValue("Color.Chart.1", meta), 0.2);
    }
  },
  "Color.Chart.Brighten.2": {
    valueFunc: (meta) => {
      return brighten(getValue("Color.Chart.2", meta), 0.2);
    }
  },
  "Color.Chart.Brighten.3": {
    valueFunc: (meta) => {
      return brighten(getValue("Color.Chart.3", meta), 0.2);
    }
  },
  "Color.Chart.Brighten.4": {
    valueFunc: (meta) => {
      return brighten(getValue("Color.Chart.4", meta), 0.2);
    }
  },
  "Color.Chart.Brighten.5": {
    valueFunc: (meta) => {
      return brighten(getValue("Color.Chart.5", meta), 0.2);
    }
  },
  "Color.Chart.Brighten.6": {
    valueFunc: (meta) => {
      return brighten(getValue("Color.Chart.6", meta), 0.2);
    }
  },
  "Color.Chart.Brighten.7": {
    valueFunc: (meta) => {
      return brighten(getValue("Color.Chart.7", meta), 0.2);
    }
  },
  "Color.Chart.Brighten.8": {
    valueFunc: (meta) => {
      return brighten(getValue("Color.Chart.8", meta), 0.2);
    }
  },
  "Color.Chart.Brighten.9": {
    valueFunc: (meta) => {
      return brighten(getValue("Color.Chart.9", meta), 0.2);
    }
  },
  "Color.Chart.Brighten.10": {
    valueFunc: (meta) => {
      return brighten(getValue("Color.Chart.10", meta), 0.2);
    }
  }
};
